import React, { useState } from 'react';
import API from '../utils/api';
import config from '../utils/config';
import toast from 'react-hot-toast';

export default function Contact() {
  const [form, setForm] = useState({
    name: '',
    contact: '',
    subject: 'General Inquiry',
    message: '',
  });

  const [sent, setSent] = useState(false);

  const set = (k, v) => {
    if (k === 'contact') {
      v = v.replace(/\D/g, '').slice(0, 10);
    }

    setForm((f) => ({ ...f, [k]: v }));
  };

  const submit = async () => {
    if (!form.name || !form.contact || !form.message) {
      return toast.error('Please fill all fields');
    }

    if (form.contact.length !== 10) {
      return toast.error('Please enter a valid 10-digit mobile number');
    }

    try {
      await API.post('/contact', form);
      setSent(true);
      toast.success('Message sent!');
    } catch {
      toast.error('Failed to send. Please try WhatsApp.');
    }
  };

  const contactItems = [
    ['📍', 'Visit Us', config.address],
    ['📞', 'Call Us', config.phone],
    ['✉️', 'Email', config.email],
    ['🕐', 'Hours', config.storeHours],
  ];

  return (
    <div className="page-enter">
      <div style={{ background:'var(--cream)', padding:'60px 24px', textAlign:'center', borderBottom:'1px solid var(--border)' }}>
        <p style={{ fontSize:11, letterSpacing:4, textTransform:'uppercase', color:'var(--champagne)', marginBottom:12 }}>Get in Touch</p>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:'clamp(36px,5vw,56px)', fontWeight:300 }}>Contact Us</h1>
      </div>

      <div style={{ maxWidth:1000, margin:'0 auto', padding:'60px 24px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:60 }}>
        <div>
          <h2 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:32, fontWeight:300, marginBottom:16 }}>Let's Create Something Beautiful</h2>
          <p style={{ fontSize:15, color:'var(--text-mid)', lineHeight:1.8, marginBottom:32 }}>Custom pieces, bridal consultations, or questions — we're here for you.</p>

          {contactItems.map(([icon, label, val]) => (
            <div key={label} style={{ display:'flex', gap:12, marginBottom:16, alignItems:'flex-start' }}>
              <div style={{ width:40, height:40, background:'var(--cream)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, flexShrink:0 }}>{icon}</div>
              <div><strong style={{ fontSize:14 }}>{label}</strong><br /><span style={{ fontSize:13, color:'var(--text-light)' }}>{val}</span></div>
            </div>
          ))}

          <a href={config.whatsappUrl()} target="_blank" rel="noreferrer"
             className="btn btn-whatsapp btn-lg" style={{ textDecoration:'none', display:'inline-flex', marginTop:8 }}>
            💬 WhatsApp Us
          </a>
        </div>

        <div style={{ background:'white', border:'1px solid var(--border)', borderRadius:4, padding:32 }}>
          {sent ? (
            <div style={{ textAlign:'center', padding:'40px 0' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>✅</div>
              <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:24, marginBottom:8 }}>Message Sent!</h3>
              <p style={{ color:'var(--text-light)' }}>We'll get back to you within 24 hours.</p>
            </div>
          ) : (
            <>
              <h3 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:24, marginBottom:20 }}>Send an Inquiry</h3>

              <div className="form-group">
                <label className="form-label">Name</label>
                <input
                  className="form-input"
                  type="text"
                  value={form.name}
                  onChange={(e) => set('name', e.target.value)}
                  placeholder="Full name"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Mobile Number</label>
                <input
                  className="form-input"
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]{10}"
                  maxLength={10}
                  value={form.contact}
                  onChange={(e) => set('contact', e.target.value)}
                  placeholder="99999 99999"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Subject</label>
                <select className="form-input" value={form.subject} onChange={(e) => set('subject', e.target.value)}>
                  {['General Inquiry','Custom Order','Bridal Consultation','Product Information','Order Status'].map((s) => <option key={s}>{s}</option>)}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  className="form-input"
                  rows={4}
                  value={form.message}
                  onChange={(e) => set('message', e.target.value)}
                  placeholder="Tell us how we can help..."
                />
              </div>

              <button className="btn btn-primary btn-full btn-lg" onClick={submit}>Send Message</button>
            </>
          )}
        </div>
      </div>

      <style>{`
        @media(max-width:768px){
          div[style*="1fr 1fr"]{
            grid-template-columns:1fr!important;
          }
        }
      `}</style>
    </div>
  );
}